/**
 * @file index.tsx
 *
 * @fileoverview Metatag component utility functions.
 */

/**
 * Removes an item from the querystring of the current URL.
 */
export const removeUnusedItemsFromQuerystring = (querystringUrl: string) => {
  if (querystringUrl.split('?').length === 1) {
    return querystringUrl;
  }
  const querystring = new URLSearchParams(querystringUrl.split('?')[1]);
  const unusedItems = ['jobId', 'path', 'router'];
  unusedItems.forEach((item) => querystring.delete(item));
  const querystringValue = querystring.toString();
  const separator = querystringValue.length > 0 ? '?' : '';
  return `${querystringUrl.split('?')[0]}${separator}${querystringValue}`;
};
